import ListFieldsGeneric from './ListFieldsGeneric'
let ListFields = ListFieldsGeneric('Forschungsprojekt')

export default {
  label: 'Forschungsprojekt',
  route: 'forschungsprojekt',
  className: 'forschungsprojekt',
  fields: [
    ListFields.SortableTimestamp('_updateDate', false, 'updateDate', true),
    ListFields.SortableTimestamp('_createDate', false, 'createDate', true),
    ListFields.SortableReference('organisationseinheit', false),
    ListFields.UnsortableReference('weitereOrganisationseinheiten', false),
    // deprecated
    // ListFields.SortableReference('projektLeiter', true),
    {
      ...ListFields.UnsortableReference('projektleiter', true),
      linkNested: 'person',
    },
    ListFields.UnsortableReference('antragsteller', false),
    ListFields.SortableField('titelDE', true),
    ListFields.SortableField('titelEN', true),
    ListFields.SortableDate('projektBeginn', false),
    ListFields.SortableDate('projektEnde', false),
    ListFields.UnsortableReference('foerderung', false, true),
    {
      label: `Forschungsprojekt.list.column.sdg`,
      field: 'sdg',
      key: 'sdg',
      render: 'stringRep',
      tableVisible: false,
      plain: true,
    },
    {
      label: `Forschungsprojekt.list.column.foerderkennzeichen`,
      field: 'foerderung',
      key: 'fkz',
      render: (f) => f.foerderkennzeichen,
      tableVisible: false,
      plain: true,
    },
    ListFields.SortableBoolean('istFinal', false),
    ListFields.SortableField('uebergeordnetesProjekt', false)
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/Forschungsprojekt.js